import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import { Authority } from '../models/Authority'
import navigation from './modules/navigation'

Vue.use(Vuex)

const iniState = {
    userId: "",
    userToken: "",
    roles:{
        roleSales: false,
        roleLeader: false,
        roleManager: false,
        roleBusinessAdmin: false,
        roleWorkingHoursAdmin: false,
    }
}

const store = new Vuex.Store({
    state: iniState,
    mutations: {
        updateUser(state, user) {
            state.userId = user.userId;
            state.userToken = user.userToken;
        },
        clearUser(state) {
            state.userId = "";
            state.userToken = "";
        },
        setUserRole(state, authority: Authority) {
            state.roles.roleSales = authority.roleSales
            state.roles.roleLeader = authority.roleLeader
            state.roles.roleManager = authority.roleManager
            state.roles.roleBusinessAdmin = authority.roleBusinessAdmin
            state.roles.roleWorkingHoursAdmin = authority.roleWorkingHoursAdmin
        }
    },
    actions: {
        auth(context, user) {
            context.commit('updateUser', user);
        },
        clear(context) {
            context.commit('clearUser');
        },
        setRole(context, authority: Authority) {
            context.commit('setUserRole', authority);
        }

    },
    modules: { navigation},
    strict: true,
    plugins: [createPersistedState({
        key: 'SampleApp',
        paths: ['userToken'],
        storage: window.sessionStorage
    })],
    getters: {
        userRoles: state => state.roles
    }
})

export default store
